module.exports = "main {\n  padding: 1em;\n  font-family: Arial, Helvetica, sans-serif;\n  text-align: left;\n  margin-top: 50px;\n  display: block;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app.component.css
 ** module id = 371
 ** module chunks = 0
 **/